import { TextField } from '@mui/material'
import { GridRenderHeaderFilterProps, useGridApiContext } from '@mui/x-data-grid-pro'
import React, { useState, useEffect, useRef } from 'react'

import { useFeedbackGridContext } from '../../context/FeedbackGridContext'

export const TextHeaderFilter: React.FC<GridRenderHeaderFilterProps> = ({ item, colDef, inputRef }) => {
	const apiRef = useGridApiContext()
	const { translations } = useFeedbackGridContext()
	const [value, setValue] = useState(item.value || '')
	const debounceTimeoutRef = useRef<any>(null)

	useEffect(() => {
		setValue(item.value || '')
	}, [item.value])

	const handleChange = (newValue: string) => {
		setValue(newValue)

		if (debounceTimeoutRef.current) {
			clearTimeout(debounceTimeoutRef.current)
		}

		debounceTimeoutRef.current = setTimeout(() => {
			apiRef.current.upsertFilterItem({
				...item,
				value: newValue,
				operator: 'contains',
			})
		}, 300)
	}

	return (
		<TextField
			fullWidth
			variant="standard"
			size="small"
			value={value}
			inputRef={inputRef}
			onChange={(e) => handleChange(e.target.value)}
			onFocus={() => apiRef.current.startHeaderFilterEditMode(colDef.field)}
			onBlur={() => apiRef.current.stopHeaderFilterEditMode()}
			placeholder={colDef.headerName}
			sx={{
				'& .MuiInputBase-root': {
					height: '100%',
					py: '3px',
				},
			}}
		/>
	)
}
